import { observer } from "mobx-react";
import { Button } from "primereact/button";
import React, { useContext } from "react";
import { useLocStore } from "../../../../wsLocalization";
import { LocContext } from "../../../../wsLocalization/LocContext";
import { UserInfo } from "../../../../WSUtils/UserInfo";
import { UserInfoContext } from "../../../../WSUtils/UserInfoContext";
import { sentryAssertData } from "../../../../WSUtils/wsSentry";
import { CVEditDocument } from "./CVEditDocument";

export const CVEditDownloadDocumentButton = observer(
  ({ cveDocument }: CVEditDownloadDocumentButtonProps) => {
    const userInfo = useContext(UserInfoContext);
    const L = useLocStore(LocContext.CV);

    return (
      <Button
        icon="pi pi-download"
        className="p-button-rounded p-button-text p-button-icon-only cve-document-list-download"
        title={L.id("c4cc9a963994").loc("Last ned dokument")}
        onClick={(evt) => {
          onDownloadDocumentClick(evt, userInfo, cveDocument);
        }}
      />
    );
  }
);

export interface CVEditDownloadDocumentButtonProps {
  cveDocument: CVEditDocument;
}

export const onDownloadDocumentClick = async (
  evt,
  userInfo: UserInfo,
  cveDocument: CVEditDocument
) => {
  evt.preventDefault();

  const tokenResponse =
    await userInfo.fullAPI.documentsAPI.getDownloadDocumentToken({
      idDocument: cveDocument.id,
      userInfo,
    });

  sentryAssertData(tokenResponse, {
    userInfo,
  });

  if (!tokenResponse.ok) return;

  const downloadUrl = userInfo.fullAPI.documentsAPI.getDocumentDownloadUrl({
    idConcern: userInfo.idConcern,
    idCandidate: userInfo.idCandidate,
    idDocument: cveDocument.id,
    downloadDocumentToken: tokenResponse.item,
  });

  sentryAssertData(downloadUrl, { userInfo });

  window.location.href = downloadUrl.url;

  return false;
};
